/**
 * Cache Configuration Constants
 * Centralized cache timing constants for React Query
 */

export const CACHE_TIMES = {
  // Stale times (when data is considered fresh)
  VEHICLE_STATUS: 30 * 1000, // 30 seconds
  SHORT_LIVED: 5 * 60 * 1000, // 5 minutes
  MEDIUM: 10 * 60 * 1000, // 10 minutes
  LONG: 30 * 60 * 1000, // 30 minutes
  VERY_LONG: 60 * 60 * 1000, // 1 hour

  // Cache times (how long to keep in cache)
  SHORT_CACHE: 10 * 60 * 1000, // 10 minutes
  MEDIUM_CACHE: 30 * 60 * 1000, // 30 minutes
  LONG_CACHE: 60 * 60 * 1000, // 1 hour
  VERY_LONG_CACHE: 2 * 60 * 60 * 1000, // 2 hours

  // Refetch intervals
  FREQUENT: 60 * 1000, // 1 minute
  PERIODIC: 30 * 60 * 1000, // 30 minutes
}
